import React, {useState, useEffect, useMemo} from 'react'
import { useGetDevice } from "../../../../api/userInfo";
import MultiFieldWithIconItem from './multi-field-with-icon-item';
import { InputWithLabel } from 'src/components/ui/inputFields/input-with-label';
import { useWidgetSetupStore } from 'src/context/stores';


//TODO: to refactor later
const MultipleFieldWithIconSetup = ({clearForm, submitForm, widgetDetails, updateSetupDetails, setupDetails, selectedWidget, isChart}) => {
    const {deviceList, isLoadingDeviceList, isErrorDeviceList} = useGetDevice(localStorage.getItem('plantId'));
    const [fields, setFields] =useState([{}])
    const [widgetTitle, updateWidgetTitle] = useWidgetSetupStore((state) => [state.widgetTitle, state.updateWidgetTitle] )

    // console.log(widgetDetails, "details")

 
    useEffect(() => {
        if(widgetDetails){
            setFields(widgetDetails?.setup?.measurement)
        }
    }, []);


    
    const addField = () => {
        setFields([...fields, {}]);
    };
    

    const removeField = (index) => {
        const newFields = [...fields];
        newFields.splice(index, 1);
        setFields(newFields);

        const updatedMeasurement = [...(setupDetails?.measurement || [])]; // Create a copy of the measurement array
        updatedMeasurement.splice(index, 1); // Remove the specific element

        updateSetupDetails({
            ...setupDetails,
            measurement: updatedMeasurement
        });
    };

 

   
    return ( 
        <>
       
        <section>

        <InputWithLabel label="Title" placeholder="Title of widget" name={`title`} required 
                            onChange={e=> updateWidgetTitle(e.target.value)} 
                            defaultValue={widgetTitle}
                            />
            {fields?.map((field, index) => (
                // TODO: to refactor later (props drilling is not good)
               <MultiFieldWithIconItem
               isChart={isChart}
               totalFields={fields?.length>1}
               updateSetupDetails={updateSetupDetails}
               deviceList={deviceList?.devices}
               selectedWidget={selectedWidget}
               setupDetails={setupDetails}
               key={`${JSON.stringify(field)}-${index}`}
               removeField={removeField}
               defaultValue={field}
               fieldIndex={index}
           />

            ))}

        <button onClick={addField} type='button' className='inline-flex items-center gap-1 p-1 text-[11px] hover:border-primary border rounded-md'> <i className="ri-add-circle-line"></i>Add Field</button>


         </section>
        
        
        {/* ------------ submit button */}
        <div className='flex flex-row justify-between gap-4 mt-4'>
            <button  type="button" onClick={()=> clearForm()} className='w-1/2 py-2 text-center border border-gray-300 rounded-md text-vekin hover:shadow-md'>
                Cancel
            </button>

            <button type="button" onClick={()=> submitForm()}  className='w-1/2 py-2 text-center text-white rounded-md bg-vekin hover:shadow-md'>
                Submit
            </button>  

        </div>
</>
     );
}
 
export default MultipleFieldWithIconSetup;